import { defineStore } from 'pinia'
import { nextTick, reactive } from 'vue'

export const useSchmitzStore = defineStore('schmitzStore', {
  state: () => {
    return {
      currentStepKey: null,
      currentExpandedKey: null,
      previousStepKey: null,
      previousAccordionKey: null,
      nextAccordionKey: null,
      nextStepKey: null,
      nextStep: null,
      vehicleSelectionError: null,
      allStepsSelected: Boolean,
      months: {
        '01': 'Januar',
        '02': 'Februar',
        '03': 'März',
        '04': 'April',
        '05': 'Mai',
        '06': 'Juni',
        '07': 'Juli',
        '08': 'August',
        '09': 'September',
        10: 'Oktober',
        11: 'November',
        12: 'Dezember'
      },
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ],
      requestData: {},
      responseData: {},
      responseDataCheck: false,
      requestError: null,
      error: null,
      loading: reactive(false),
      accordion: reactive({
        accordion1: {
          title: 'Modell',
          content: 'model',
          steps: {
            model: {
              title: 'Modell',
              selectedOption: {},
              selected: false,
              options: [
                { value: 'Model3', label: 'Model 3' },
                { value: 'ModelY', label: 'Model Y' }
              ]
            },
            modelVariant: {
              title: 'Variante',
              selectedOption: {},
              selected: false,
              options: [
                // Is defined in generateModelVariantOptions()
              ]
            },
            // this step is restricted by the selectedOption() case modelVariant
            driveType: {
              title: 'Antrieb',
              selectedOption: {},
              selected: false,
              options: [
                { value: 'AWD', label: 'Allrad (AWD)' },
                { value: 'RWD', label: 'Hinterradantrieb(RWD)' }
              ]
            }
          }
        },
        accordion2: {
          title: 'Fahrzeugdaten',
          content: 'carRegistration',
          steps: {
            carRegistration: {
              selectedOption: { mileage: 0, availability: true },
              selected: false,
              visited: false
            }
          }
        },
        accordion3: {
          title: 'Außen- und Innenfarbe',
          content: 'colors',
          steps: {
            bodyColor: {
              title: 'Karosseriefarbe',
              selectedOption: {},
              selected: false,
              options: [
                { value: 'white', label: 'Weiß' },
                { value: 'silver', label: 'Silber' },
                { value: 'black', label: 'Schwarz' },
                { value: 'gray', label: 'Grau' },
                { value: 'blue', label: 'Blau' },
                { value: 'red', label: 'Rot' }
              ]
            },
            interiorColor: {
              title: 'Innenfarbe',
              selectedOption: {},
              selected: false,
              options: [
                { value: 'black', label: 'Schwarz' },
                { value: 'white', label: 'Weiß' }
              ]
            },
            // this step is restricted by the selectedOption() case modelVariant
            rimColor: {
              title: 'Farbe der Felgen',
              selectedOption: {},
              selected: false,
              options: [
                { value: 'black', label: 'Schwarz' },
                { value: 'white', label: 'Weiß' }
              ]
            }
          }
        },
        accordion4: {
          title: 'Sonderausstattung',
          content: 'equipment',
          steps: {
            autopilot: {
              title: 'Autonomes Fahren',
              selectedOption: { value: 'StandardAutopilot', label: 'Autopilot (Standard)' },
              selected: false,
              options: [
                { value: 'StandardAutopilot', label: 'Autopilot (Standard)' },
                { value: 'ExtendedAutopilot', label: 'Erweiterter Autopilot (EAP)' },
                { value: 'FullServiceDrive', label: 'volles Potenzial für autonomes Fahren (FSD)' }
                // not used anymore 2025-10-22 AXN-6602
                // { value: 'NoAutopilot', label: 'Kein Autopilot' }
              ]
            },
            rims: {
              title: 'Felgen',
              selectedOption: { value: 'OriginalRims', label: 'Original Felgen' },
              selected: false,
              options: [
                { value: 'OriginalRims', label: 'Original Felgen' },
                { value: 'AccessoryRims', label: 'Zubehör Felgen' }
              ]
            },
            rimType: {
              title: 'Felgentypen',
              selectedOption: {},
              selected: false,
              options: [
                // is defined in generateRimTypeOptions()
              ]
            },
            customEquipment: {
              title: 'zusätzliche Ausstattung',
              selectedOption: [],
              selected: false,
              options: [
                // is defined in generateModelVariantOptions()
              ]
            }
          }
        },
        accordion5: {
          title: 'Fahrzeugzustand',
          content: 'damage',
          steps: {
            accident: {
              title: 'Unfall',
              selectedOption: { accident: false, accidentDescription: '' },
              selected: false
            },
            damage: {
              title: 'aktuelle Beschädigungen',
              selectedOption: { damage: false, damageDescription: '' },
              selected: false
            }
          }
        },
        accordion6: {
          title: 'Preis',
          content: 'priceRequest',
          steps: {
            price: {
              title: 'Preisvorstellung',
              selectedOption: { saleType: 'Privater Verkauf', mwSt: false },
              selected: false
            },
            finance: {
              title: 'Finanzierung',
              selectedOption: { financing: false },
              selected: false
            }
          }
        },
        accordion7: {
          title: 'Kostenlos & unverbindlich anfragen',
          content: 'submit',
          steps: {
            submit: {
              selectedOption: {
                firstName: '',
                lastName: '',
                email: '',
                privacyPolicy: false,
                marketing: []
              },
              selected: false,
              visited: false,
              options: [
                { value: 'Google', label: 'Google' },
                { value: 'Socials', label: 'Instagram/TikTok/YouTube' },
                { value: 'Mobile.de/AS24/Kleinanz.', label: 'Mobile.de/AS24/Kleinanz.' },
                { value: 'Advertisment', label: ' Werbung Tesla Welt' },
                // not used anymore 2025-10-22 AXN-6602
                // { value: 'EFIEBER', label: 'EFIEBER' },
                { value: 'Returning Customer', label: 'bereits bekannt' },
                { value: 'Other', label: 'sonstiges' }
              ]
            }
          }
        }
      })
    }
  },
  watch: {},
  actions: {
    findExpandedIndex(currentStepKey) {
      Object.keys(this.accordion).forEach((accordionKey) => {
        const accordion = this.accordion[accordionKey]
        Object.keys(accordion.steps).forEach((stepKey) => {
          if (stepKey === currentStepKey) {
            this.currentExpandedKey = accordionKey
          }
        })
      })
      return this.currentExpandedKey
    },
    defineStepKey() {
      this.nextStep = Object.values(this.accordion).find((accordion) =>
        Object.values(accordion.steps).find((step) => !step.selected)
      )
      // console.log(this.accordion)
      if (this.nextStep) {
        const stepKeys = Object.keys(this.nextStep.steps)
        for (const stepKey of stepKeys) {
          if (!this.nextStep.steps[stepKey].selected) {
            this.currentStepKey = stepKey
            this.currentExpandedKey = this.findExpandedIndex(this.currentStepKey)
            // console.log(this.currentStepKey)
            // console.log(this.currentExpandedKey)
            return stepKey
          }
        }
      }
      return null
    },
    resetStep(accordionKey, stepKey, { emptyValue } = {}) {
      const emptyValueByStepKey = {
        customEquipment: [],
        carRegistration: { mileage: 0, availability: true },
        accident: { accident: false, accidentDescription: '' },
        damage: { damage: false, damageDescription: '' },
        price: { saleType: 'Privater Verkauf', mwSt: false },
        finance: { financing: false },
        submit: {
          firstName: '',
          lastName: '',
          email: '',
          privacyPolicy: false,
          marketing: []
        }
      }
      // These steps end up as labels in the request payload, so a reset must never leave them
      // empty. They fall back to their first option and stay unconfirmed (selected = false).
      const fallbackToFirstOption = ['autopilot', 'interiorColor', 'rimColor']
      const step = this.accordion[accordionKey].steps[stepKey]
      const firstOption =
        fallbackToFirstOption.includes(stepKey) && step.options?.length
          ? { ...step.options[0] }
          : undefined
      step.selected = false
      step.selectedOption = emptyValue ?? emptyValueByStepKey[stepKey] ?? firstOption ?? {}
    },
    toggleAccordion(index) {
      // console.log(`toggleAccordion called with index: ${index}`)
      const accordion = this.accordion[index]
      // console.log(`accordion at index ${index}:`, accordion)

      this.allStepsSelected = Object.values(accordion.steps).every((step) => step.selected)
      // console.log(`allStepsSelected: ${this.allStepsSelected}`)

      const currentStep = this.defineStepKey()
      // console.log(`currentStep: ${currentStep}`)

      let lastStepWithOptions = null
      // console.log(`lastStepWithOptions: ${lastStepWithOptions}`)

      if (this.allStepsSelected || currentStep) {
        // console.log(
        //   `setting previousAccordionKey form toggle Accordion to ${this.currentExpandedKey}`
        // )
        // console.log(`setting currentExpandedKey form toggle Accordion to ${index}`)
        this.currentExpandedKey = index

        const firstUnselectedStep = Object.values(accordion.steps).find(
          (step) => step.selected === false
        )
        // console.log(`firstUnselectedStep:`, firstUnselectedStep)

        if (!firstUnselectedStep) {
          // console.log('No unselected steps found')
          // Find the first step with selected set to false

          if (firstUnselectedStep) {
            // console.log('Finding currentStepKey for firstUnselectedStep')
            // this.currentStepKey = Object.keys(accordion.steps).find(
            //   (key) => accordion.steps[key] === firstUnselectedStep
            // )
            // console.log(`currentStepKey for firstUnselectedStep: ${this.currentStepKey}`)
          } else {
            // If no unselected steps, set currentStepKey to the first step
            // console.log('No unselected steps, setting currentStepKey to the last step')
            this.currentStepKey = Object.keys(accordion.steps)[
              Object.keys(accordion.steps).length - 1
            ]
            // console.log(`currentStepKey set to last step: ${this.currentStepKey}`)

            if (this.currentStepKey === 'rimColor') {
              // console.log('Checking rimColor selectedOption')
              if (this.accordion.accordion3.steps.rimColor.selectedOption.value === 'Standard') {
                // console.log(
                //   'rimColor selectedOption is Standard, setting currentStepKey to interiorColor'
                // )
                this.currentStepKey = 'interiorColor'
              }
            }
          }
        } else {
          // console.log('Finding currentStepKey for firstUnselectedStep')
          lastStepWithOptions = firstUnselectedStep // Set lastStepWithOptions auf firstUnselectedStep
          this.currentStepKey = Object.keys(accordion.steps).find(
            (key) => accordion.steps[key] === lastStepWithOptions
          )
          // console.log(`currentStepKey for firstUnselectedStep: ${this.currentStepKey}`)
        }
        // console.log(`currentStepKey form toggle Accordion: ${this.currentStepKey}`)

        // Update previousStepKey and previousAccordionKey
        // console.log(`previousStepKey before update: ${this.previousStepKey}`)
        // console.log(`previousAccordionKey before update: ${this.previousAccordionKey}`)
        this.previousStepKey = this.currentStepKey
        this.previousAccordionKey = this.currentExpandedKey
        // console.log(`previousStepKey after update: ${this.previousStepKey}`)
        // console.log(`previousAccordionKey after update: ${this.previousAccordionKey}`)

        // Update nextAccordionKey and nextStepKey
        const accordionKeys = Object.keys(this.accordion)
        // console.log(`accordionKeys: ${accordionKeys}`)
        const currentAccordionIndex = accordionKeys.indexOf(this.currentExpandedKey)
        // console.log(`currentAccordionIndex: ${currentAccordionIndex}`)
        if (currentAccordionIndex < accordionKeys.length - 1) {
          // console.log('Setting nextAccordionKey and nextStepKey')
          this.nextAccordionKey = accordionKeys[currentAccordionIndex + 1]
          this.nextStepKey = Object.keys(this.accordion[this.nextAccordionKey].steps)[0]
          // console.log(`nextAccordionKey: ${this.nextAccordionKey}`)
          // console.log(`nextStepKey: ${this.nextStepKey}`)
        } else {
          // console.log('No next accordion, setting nextAccordionKey and nextStepKey to null')
          this.nextAccordionKey = null
          this.nextStepKey = null
        }
      } else {
        // console.log(`not all steps selected, toggling to last selected step`)
        if (this.previousAccordionKey !== null) {
          // console.log(`toggling back to previous accordion index: ${this.previousAccordionKey}`)
          this.currentExpandedKey = this.previousAccordionKey
          this.previousAccordionKey = null
        } else {
          const currentStepKey = this.defineStepKey()
          // console.log(`currentStepKey form toggle Accordion: ${currentStepKey}`)
          if (currentStepKey) {
            // console.log(`finding expanded index for current step key`)
            this.currentExpandedKey = this.findExpandedIndex(currentStepKey)
          }
        }
      }
      // console.log(`final currentExpandedKey: ${this.currentExpandedKey}`)
      // console.log(`final previousAccordionKey: ${this.previousAccordionKey}`)
    },
    // Recomputes nextStepKey/nextAccordionKey for wherever currentStepKey/currentExpandedKey
    // currently point to. Safe to call any number of times - it only reads step state.
    syncNextPointers() {
      // The current step itself may still be unconfirmed (e.g. defineStepKey() just jumped to it
      // as "the next incomplete step"). There is nothing to skip forward to in that case - leave
      // both pointers null so callers fall back to defineStepKey() instead of prematurely
      // advancing past a step that was never actually completed.
      if (!this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selected) {
        this.nextAccordionKey = null
        this.nextStepKey = null
        return
      }

      // Find the Index of the current step
      const currentStepIndex = Object.keys(this.accordion[this.currentExpandedKey].steps).indexOf(
        this.currentStepKey
      )

      // Find the Index of the current accordion
      const accordionKeys = Object.keys(this.accordion)
      const currentAccordionIndex = accordionKeys.indexOf(this.currentExpandedKey)

      // if current step is not the last step, update nextAccordionKey and nextStepKey
      if (
        currentStepIndex <
        Object.keys(this.accordion[this.currentExpandedKey].steps).length - 1
      ) {
        const nextStepKey = Object.keys(this.accordion[this.currentExpandedKey].steps)[
          currentStepIndex + 1
        ]

        // Verify if last step is selected
        if (!this.accordion[this.currentExpandedKey].steps[nextStepKey].selected) {
          this.nextAccordionKey = null
          this.nextStepKey = null
        } else {
          this.nextAccordionKey = this.currentExpandedKey
          this.nextStepKey = nextStepKey
        }
      } else if (currentAccordionIndex < accordionKeys.length - 1) {
        // If the current step is the last step and the current accordion is the last accordion,
        // set nextAccordionKey to the key of the next accordion
        const nextAccordionKey = accordionKeys[currentAccordionIndex + 1]
        this.nextAccordionKey = nextAccordionKey
        this.nextStepKey = Object.keys(this.accordion[nextAccordionKey].steps)[0]
      } else {
        // if the current Step is the last step and the current accordion is the last accordion,
        // set nextAccordionKey and nextStepKey null
        this.nextAccordionKey = null
        this.nextStepKey = null
      }
    },
    async goForward() {
      // console.log('goForward')

      if (this.nextAccordionKey !== null && this.nextStepKey !== null) {
        // console.log('nextAccordionKey und nextStepKey sind nicht null')
        this.previousAccordionKey = this.currentExpandedKey
        this.previousStepKey = this.currentStepKey

        this.currentExpandedKey = this.nextAccordionKey
        this.currentStepKey = this.nextStepKey
        await nextTick()

        // console.log('Aktueller Accordion-Key:', this.currentExpandedKey)
        // console.log('Aktueller Step-Key:', this.currentStepKey)
        if (this.currentStepKey === 'carRegistration') {
          if (this.accordion.accordion3.steps.rimColor.selected === false) {
            this.defineStepKey()
          }
        }
        if (this.currentStepKey === 'rimColor') {
          if (
            this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selectedOption
              .value === 'Standard'
          ) {
            this.goForward()
          }
        }
        if (this.currentStepKey === 'rims') {
          this.goForward()
        }

        this.syncNextPointers()
      } else {
        // console.log('nextAccordionKey oder nextStepKey sind null')
      }
    },
    async goBack() {
      if (this.previousAccordionKey !== null && this.previousStepKey !== null) {
        this.nextAccordionKey = this.currentExpandedKey
        this.nextStepKey = this.currentStepKey
        this.currentExpandedKey = this.previousAccordionKey
        this.currentStepKey = this.previousStepKey
        await nextTick()
        // console.log(this.accordion)
        if (this.currentStepKey === 'rimColor') {
          if (
            this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selectedOption
              .value === 'Standard'
          ) {
            this.goBack()
          }
        }
        if (this.currentStepKey === 'rimType') {
          this.goBack()
        }
        // Find the index of the current step
        const currentStepIndex = Object.keys(this.accordion[this.currentExpandedKey].steps).indexOf(
          this.currentStepKey
        )

        // Find the index of the current accordion
        const accordionKeys = Object.keys(this.accordion)
        const currentAccordionIndex = accordionKeys.indexOf(this.currentExpandedKey)

        // If the current step is not the first step, update previousAccordionKey and previousStepKey
        if (currentStepIndex > 0) {
          const previousStepKey = Object.keys(this.accordion[this.currentExpandedKey].steps)[
            currentStepIndex - 1
          ]

          this.previousAccordionKey = this.currentExpandedKey
          this.previousStepKey = previousStepKey
        } else if (currentAccordionIndex > 0) {
          // If the current step is the first step and the current accordion is not the first accordion,
          // set previousAccordionKey to the key of the previous accordion
          const previousAccordionKey = accordionKeys[currentAccordionIndex - 1]
          this.previousAccordionKey = previousAccordionKey
          this.previousStepKey = Object.keys(this.accordion[previousAccordionKey].steps)[
            Object.keys(this.accordion[previousAccordionKey].steps).length - 1
          ]
        } else {
          // If the current step is the first step and the current accordion is the first accordion,
          // set previousAccordionKey and previousStepKey to null
          this.previousAccordionKey = null
          this.previousStepKey = null
        }
      } else {
        // Handle the case where the user is on the first step
        // console.log('You are already on the first step')
      }
    },
    async nextSelection() {
      // Save the current step and accordion keys as previous keys

      this.previousStepKey = this.currentStepKey
      this.previousAccordionKey = this.currentExpandedKey

      // console.log('after first define', this.currentStepKey)

      let stepKey = this.currentStepKey
      let step = this.accordion[this.currentExpandedKey].steps[this.currentStepKey]
      // console.log(step.selected)

      switch (stepKey) {
        case 'model':
          if (!step.selected) {
            this.vehicleSelectionError = 'Kein Model ausgewählt!'
            return
          }
          break
        case 'modelVariant':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'driveType':
          if (!step.selected) {
            this.vehicleSelectionError = 'Kein Antrieb ausgewählt!'
            return
          } else {
            if (this.nextStepKey === null) {
              step.selected = true
              this.defineStepKey()
              this.syncNextPointers()
            } else {
              this.goForward()
            }
          }
          break
        // case 'rimColor':
        //   if (this.nextStepKey === null) {
        //     step.selected = true
        //     this.defineStepKey()
        //   } else {
        //     this.goForward()
        //   }
        //   break
        case 'carRegistration':
          if (
            !step.selectedOption.registration &&
            !step.selectedOption.mileage &&
            !step.selectedOption.previousOwner &&
            !step.selectedOption.location
          ) {
            this.vehicleSelectionError =
              'Erstzulassung darf nicht leer sein! Kilometerstand darf nicht 0 sein! Anzahl der Halter darf nicht leer sein! PLZ darf nicht leer sein!'
            return
          } else if (
            !step.selectedOption.registration &&
            !step.selectedOption.mileage &&
            !step.selectedOption.location
          ) {
            this.vehicleSelectionError =
              'Erstzulassung darf nicht leer sein! Kilometerstand darf nicht 0 sein! PLZ darf nicht leer sein!'
            return
          } else if (
            !step.selectedOption.mileage &&
            !step.selectedOption.previousOwner &&
            !step.selectedOption.location
          ) {
            this.vehicleSelectionError =
              'Kilometerstand darf nicht 0 sein! Anzahl der Halter darf nicht leer sein! PLZ darf nicht leer sein!'
            return
          } else if (
            !step.selectedOption.registration &&
            !step.selectedOption.previousOwner &&
            !step.selectedOption.location
          ) {
            this.vehicleSelectionError =
              'Erstzulassung darf nicht leer sein! Anzahl der Halter darf nicht leer sein! PLZ darf nicht leer sein!'
            return
          } else if (!step.selectedOption.registration && !step.selectedOption.mileage) {
            this.vehicleSelectionError =
              'Erstzulassung darf nicht leer sein! Kilometerstand darf nicht 0 sein!'
            return
          } else if (!step.selectedOption.registration && !step.selectedOption.location) {
            this.vehicleSelectionError =
              'Erstzulassung darf nicht leer sein! PLZ darf nicht leer sein!'
            return
          } else if (!step.selectedOption.location && !step.selectedOption.previousOwner) {
            this.vehicleSelectionError =
              'PLZ darf nicht leer sein! Anzahl der Halter darf nicht leer sein!'
            return
          } else if (!step.selectedOption.mileage && !step.selectedOption.previousOwner) {
            this.vehicleSelectionError =
              'Kilometerstand darf nicht 0 sein! Anzahl der Halter darf nicht leer sein!'
            return
          } else if (!step.selectedOption.registration && !step.selectedOption.previousOwner) {
            this.vehicleSelectionError =
              'Erstzulassung darf nicht leer sein! Anzahl der Halter darf nicht leer sein!'
            return
          } else if (!step.selectedOption.registration) {
            this.vehicleSelectionError = 'Erstzulassung darf nicht leer sein!'
            return
          } else if (!step.selectedOption.mileage) {
            this.vehicleSelectionError = 'Kilometerstand darf nicht 0 sein!'
            return
          } else if (!step.selectedOption.previousOwner) {
            this.vehicleSelectionError = 'Anzahl der Halter darf nicht leer sein!'
            return
          } else if (!step.selectedOption.location) {
            this.vehicleSelectionError = 'PLZ darf nicht leer sein!'
            return
          } else if (!step.selectedOption.availability) {
            if (!step.selectedOption.availableFrom) {
              this.vehicleSelectionError = 'Verfügbarkeit darf nicht leer sein'
              return
            }
            if (this.nextStepKey === null) {
              step.selected = true
              this.defineStepKey()
              this.syncNextPointers()
            } else {
              this.goForward()
            }
          } else {
            this.vehicleSelectionError = null
            if (this.nextStepKey === null) {
              step.selected = true
              this.defineStepKey()
              this.syncNextPointers()
            } else {
              this.goForward()
            }
          }

          break
        case 'autopilot':
          step.selected = true
          if (!this.accordion.accordion4.steps.rims.selected) {
            this.accordion.accordion4.steps.rims.selected = true
          }
          nextTick()
          if (this.nextStepKey === null) {
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'rims':
          step.selected = true
          if (!this.accordion.accordion4.steps.rimType.selected) {
            this.accordion.accordion4.steps.rimType.selected = true
          }
          if (this.nextStepKey === null) {
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          // console.log(this.accordion)

          break
        case 'rimType':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'customEquipment':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }

          break
        case 'damage':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'accident':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'price':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'finance':
          if (this.nextStepKey === null) {
            step.selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break

        default:
          break
      }
    },
    selectOptions(option, stepKey) {
      this.vehicleSelectionError = null

      this.previousStepKey = this.currentStepKey
      this.previousAccordionKey = this.currentExpandedKey

      if (!this.accordion[this.currentExpandedKey].steps[stepKey].selectedOption) {
        this.accordion[this.currentExpandedKey].steps[stepKey].selectedOption = {}
      }
      this.accordion[this.currentExpandedKey].steps[stepKey].selectedOption = option

      this.currentStepKey = stepKey
      switch (stepKey) {
        case 'model':
          this.vehicleSelectionError = null
          if (!this.accordion[this.currentExpandedKey].steps[stepKey].selected) {
            this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selected = true
            this.generateModelVariantOptions(option)
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.currentStepKey = stepKey
            this.generateModelVariantOptions(option)
            this.resetStep(this.currentExpandedKey, 'driveType')
            this.resetStep(this.currentExpandedKey, 'modelVariant')
            this.defineStepKey()
            this.syncNextPointers()
          }
          break
        case 'modelVariant':
          this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selected = true
          this.accordion.accordion3.steps.rimColor.selectedOption = {
            value: 'Standard',
            label: 'Standard'
          }
          this.accordion.accordion3.steps.rimColor.selected = true
          if (!this.accordion[this.currentExpandedKey].steps[stepKey].selected) {
            if (
              option.value === 'Model3StandardRange+' ||
              option.value === 'Model3Performance' ||
              option.value === 'ModelYStandardRange' ||
              option.value === 'ModelYPerformance'
            ) {
              this.accordion[this.currentExpandedKey].steps.driveType.selected = true
              this.accordion[this.currentExpandedKey].steps.driveType.selectedOption = {}
            }
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            if (
              option.value === 'Model3StandardRange+' ||
              option.value === 'Model3Performance' ||
              option.value === 'ModelYStandardRange' ||
              option.value === 'ModelYPerformance'
            ) {
              this.accordion[this.currentExpandedKey].steps.driveType.selected = true
              this.accordion[this.currentExpandedKey].steps.driveType.selectedOption = {}
            } else {
              this.accordion[this.currentExpandedKey].steps.driveType.selected = false
              this.accordion[this.currentExpandedKey].steps.driveType.selectedOption = {
                value: 'AWD',
                label: 'Allrad (AWD)'
              }
              this.defineStepKey()
              this.syncNextPointers()
              nextTick(async () => {
                this.accordion[this.currentExpandedKey].steps.driveType.selected = true
              })
            }
            this.generateRimTypeOptions()
          }
          break
        case 'driveType':
          this.vehicleSelectionError = null
          setTimeout(() => {
            this.accordion[this.currentExpandedKey].steps[stepKey].selected = true
          }, 0)
          break
        case 'rims':
          if (!this.accordion[this.currentExpandedKey].steps[stepKey].selected) {
            this.accordion[this.currentExpandedKey].steps[stepKey].selected = true
          }
          this.generateRimTypeOptions()
          break
        case 'rimType':
          this.accordion[this.currentExpandedKey].steps[stepKey].selected = true
          nextTick()

          break
        case 'bodyColor':
          // The interior color options do not depend on the body color, so the selection is only
          // reset when it is no longer one of the available options.
          {
            const interiorColorStep = this.accordion.accordion3.steps.interiorColor
            if (
              !interiorColorStep.options.some(
                (o) => o.value === interiorColorStep.selectedOption?.value
              )
            ) {
              this.resetStep('accordion3', 'interiorColor')
            }
          }

          if (this.nextStepKey === null) {
            this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selected = true
            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'interiorColor':
          if (!this.accordion.accordion4.steps.autopilot.selected) {
            this.accordion.accordion4.steps.autopilot.selectedOption = {
              value: 'StandardAutopilot',
              label: 'Autopilot (Standard)'
            }
          }
          if (
            this.accordion[this.currentExpandedKey].steps.rimColor.selectedOption.value ===
            'Standard'
          ) {
            this.accordion[this.currentExpandedKey].steps.rimColor.selected = true
          }

          if (this.nextStepKey === null) {
            this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selected = true

            this.defineStepKey()
            this.syncNextPointers()
          } else {
            this.goForward()
          }
          break
        case 'rimColor':
          this.nextStepKey = null
          this.nextAccordionKey = null
          this.accordion[this.currentExpandedKey].steps[this.currentStepKey].selected = true
          this.defineStepKey()
          this.syncNextPointers()

          break
        // case 'autopilot':
        //   this.accordion[this.currentExpandedKey].steps[stepKey].selected = true
        //   break
        default:
          // console.log(`Unknown stepKey: ${stepKey}`)
          break
      }
    },
    selectMutlipleCheckboxes(option, stepKey) {
      const step = this.accordion[this.currentExpandedKey].steps[stepKey]
      let selectedIndex = null
      let selectedOptionPath = null
      if (stepKey === 'submit') {
        selectedIndex = step.selectedOption.marketing.indexOf(option)
        selectedOptionPath = step.selectedOption.marketing
      } else {
        selectedIndex = step.selectedOption.indexOf(option)
        selectedOptionPath = step.selectedOption
      }

      if (selectedIndex === -1) {
        selectedOptionPath.push(option)
      } else {
        selectedOptionPath.splice(selectedIndex, 1)
      }
    },
    generateModelVariantOptions(model) {
      if (model.value === 'Model3') {
        this.accordion.accordion1.steps.modelVariant.options = [
          { value: 'Model3RWDBasisEnd25', label: 'Model 3 RWD Basis (ab Ende 2025)' },
          { value: 'Model3StandardRange+', label: 'Model 3 Standard Range +' },
          { value: 'Model3LongRange', label: 'Model 3 Long Range' },
          { value: 'Model3Performance', label: 'Model 3 Performance' }
        ]
        this.accordion.accordion4.steps.customEquipment.options = [
          { value: 'Highland', label: 'Ausführung Highland (ab 10.2023)' },
          { value: 'TrailerHitch', label: 'Anhängerkupplung' },
          { value: 'AccBoost', label: 'ACC Boost' },
          { value: 'SecondTireSetOriginal', label: '2. Radsatz (komplett original Tesla)' },
          { value: 'SecondTireSetThirdParty', label: '2. Radsatz (komplett Zubehör)' },
          { value: 'SecondTireSetTiresOnly', label: '2. Radsatz (nur Reifen)' },
          { value: 'QuerlenkerErneuert', label: 'Querlenker erneuert' },
          { value: 'HW4', label: 'HW4 (ab 05/2024 rote Linse Seitenkamera)' }
        ]
        this.accordion.accordion1.steps.modelVariant.selectedOption = {
          value: 'Model3StandardRange+',
          label: 'Model 3 Standard Range +'
        }
        this.accordion.accordion3.steps.rimColor.selectedOption = {
          value: 'Standard',
          label: 'Standard'
        }
        this.accordion.accordion3.steps.rimColor.selected = true
        this.accordion.accordion1.steps.driveType.selectedOption = {}
        this.accordion.accordion1.steps.driveType.selected = true
      } else if (model.value === 'ModelY') {
        this.accordion.accordion1.steps.modelVariant.options = [
          { value: 'ModelYRWDBasisEnd25', label: 'Model Y RWD Basis (ab Ende 2025)' },
          { value: 'ModelYStandardRange', label: 'Model Y Standard Range' },
          { value: 'ModelYLongRange', label: 'Model Y Long Range' },
          { value: 'ModelYPerformance', label: 'Model Y Performance' }
        ]
        this.accordion.accordion4.steps.customEquipment.options = [
          { value: 'Juniper', label: 'Ausführung Juniper (neues Modell ab 2025)' },
          { value: 'TrailerHitch', label: 'Anhängerkupplung' },
          { value: 'AccBoost', label: 'ACC Boost' },
          { value: 'SecondTireSetOriginal', label: '2. Radsatz (komplett original Tesla' },
          { value: 'SecondTireSetThirdParty', label: '2. Radsatz (komplett Zubehör)' },
          { value: 'SecondTireSetTiresOnly', label: '2. Radsatz (nur Reifen)' },
          { value: 'QuerlenkerErneuert', label: 'Querlenker erneuert' },
          { value: 'HW4', label: 'HW4 (ab 05/2024 rote Linse Seitenkamera)' }
        ]
        this.accordion.accordion1.steps.modelVariant.selectedOption = {
          value: 'ModelYStandardRange',
          label: 'Model Y Standard Range'
        }
        this.accordion.accordion3.steps.rimColor.selectedOption = {
          value: 'Standard',
          label: 'Standard'
        }
        this.accordion.accordion3.steps.rimColor.selected = true
        this.accordion.accordion1.steps.driveType.selectedOption = {}
        this.accordion.accordion1.steps.driveType.selected = true
      } else {
        this.accordion.accordion4.steps.customEquipment.options = []
        this.accordion.accordion1.steps.modelVariant.options = []
      }
      setTimeout(() => {
        this.generateRimTypeOptions()
      }, 0)
    },
    generateRimTypeOptions() {
      let rims = this.accordion.accordion4.steps.rims.selectedOption
      let model = this.accordion.accordion1.steps.model.selectedOption
      let modelVariant = this.accordion.accordion1.steps.modelVariant.selectedOption

      const rimType = this.accordion.accordion4.steps.rimType
      const applyRimTypeOptions = (options, defaultOption) => {
        rimType.options = options
        if (!options.some((o) => o.value === rimType.selectedOption?.value)) {
          rimType.selected = false
        }
        if (!rimType.selected) {
          rimType.selectedOption = defaultOption
        }
      }

      if (rims.value === 'OriginalRims') {
        if (model.value === 'Model3') {
          if (modelVariant.value === 'Model3Performance') {
            applyRimTypeOptions(
              [{ value: 'Model3PerformanceRims', label: '20" Felgen (Performance)' }],
              { value: 'Model3PerformanceRims', label: '20" Felgen (Performance)' }
            )
          } else {
            applyRimTypeOptions(
              [
                { value: 'EighteenInchRims', label: '18" Felgen' },
                { value: 'NineteenInchRims', label: '19" Felgen' }
              ],
              { value: 'EighteenInchRims', label: '18" Felgen' }
            )
          }
        }
        if (model.value === 'ModelY') {
          if (modelVariant.value === 'ModelYPerformance') {
            applyRimTypeOptions([{ value: 'ModelYPerformanceRims', label: '21" Überturbine' }], {
              value: 'ModelYPerformanceRims',
              label: '21" Überturbine'
            })
            return
          } else {
            applyRimTypeOptions(
              [
                { value: 'EighteenInchRims', label: '18" Felgen' },
                { value: 'NineteenInchRims', label: '19" Felgen' },
                { value: 'TwentyInchRims', label: '20" Felgen' }
              ],
              { value: 'NineteenInchRims', label: '19" Felgen' }
            )
          }
        }
      } else if (rims.value === 'AccessoryRims') {
        if (model.value === 'Model3') {
          applyRimTypeOptions(
            [
              { value: 'EighteenInchRims', label: '18" Felgen' },
              { value: 'NineteenInchRims', label: '19" Felgen' },
              { value: 'TwentyInchRims', label: '20" Felgen' }
            ],
            { value: 'EighteenInchRims', label: '18" Felgen' }
          )
        } else {
          applyRimTypeOptions(
            [
              { value: 'NineteenInchRims', label: '19" Felgen' },
              { value: 'TwentyInchRims', label: '20" Felgen' },
              { value: 'TwentyOneInchRims', label: '21" Felgen' }
            ],
            { value: 'NineteenInchRims', label: '19" Felgen' }
          )
        }
      }
    },
    displaySelected(content) {
      const accordion = this.accordion

      switch (content) {
        case 'model': {
          const modelDisplays = Object.values(accordion.accordion1.steps)
            .map((step) => {
              if (
                step.title !== 'Modell' &&
                step.selectedOption &&
                step.selectedOption.value &&
                step.selectedOption.label
              ) {
                return step.selectedOption.label
              }
            })
            .filter(Boolean)
          return modelDisplays.length > 0 ? modelDisplays.join(', ') : 'Kein Modell ausgewählt'
        }
        case 'carRegistration': {
          const carRegistration = accordion.accordion2.steps.carRegistration
          if (carRegistration.selectedOption) {
            const { registration, mileage } = carRegistration.selectedOption
            if (registration && mileage) {
              const [year, month, day] = registration.split('-')
              const formattedErstzulassung = `${day}. ${this.monthNames[month - 1]} ${year}`
              return `Erstzulassung: ${formattedErstzulassung}, Kilometerstand: ${mileage}`
            } else if (registration) {
              const [year, month, day] = registration.split('-')
              const formattedErstzulassung = `${day}. ${this.monthNames[month - 1]} ${year}`

              return `Erstzulassung: ${formattedErstzulassung}`
            } else if (mileage) {
              return `Kilometerstand: ${mileage}`
            }
          }
          return 'Erstzulassung, Kilometerstand: 0'
        }
        case 'colors': {
          const bodyColor = accordion.accordion3.steps.bodyColor.selectedOption
          const interiorColor = accordion.accordion3.steps.interiorColor.selectedOption
          const rimColor = accordion.accordion3.steps.rimColor.selectedOption
          let colorDisplays = []

          if (bodyColor && bodyColor.value && bodyColor.label) {
            colorDisplays.push(`Außen: ${bodyColor.label}`)
          }

          if (interiorColor && interiorColor.value && interiorColor.label) {
            colorDisplays.push(`Innen: ${interiorColor.label}`)
          }
          if (rimColor && rimColor.value && rimColor.label) {
            colorDisplays.push(`Felgen: ${rimColor.label}`)
          }

          return colorDisplays.length > 0 ? colorDisplays.join(', ') : accordion.accordion3.title
        }
        case 'equipment': {
          const autopilot = accordion.accordion4.steps.autopilot.selectedOption.label
          const rimType = accordion.accordion4.steps.rimType.selectedOption.label
          const customEquipment = Object.keys(
            accordion.accordion4.steps.customEquipment.selectedOption || {}
          ).length
            ? `${Object.keys(accordion.accordion4.steps.customEquipment.selectedOption || {}).length} zusätz. Ausstattungen`
            : '0 Ausgewählt'

          const equipmentDisplays = [
            autopilot && `${autopilot}`,
            rimType && `${rimType}`,
            customEquipment
          ].filter(Boolean)

          return equipmentDisplays.length > 0
            ? equipmentDisplays.join(', ')
            : accordion.accordion3.title
        }
        case 'damage': {
          const accident = accordion.accordion5.steps.accident.selectedOption.accident
          const damage = accordion.accordion5.steps.damage.selectedOption.damage

          if (accident && damage) {
            return 'Unfallfahrzeug, Beschädigt'
          } else if (accident && !damage) {
            return 'Unfallfahrzeug, ohne Beschädigungen'
          } else if (!accident && damage) {
            return 'Unfallfrei, beschädigt'
          } else {
            return 'Unfallfrei, ohne Beschädigungen'
          }
        }
        case 'priceRequest':
          return `${!accordion.accordion6.steps.price.selectedOption.saleType || accordion.accordion6.steps.price.selectedOption.saleType === 'Privater Verkauf' ? 'Verkauf von Privat' : 'gewerblicher Verkauf'}, ${!accordion.accordion6.steps.price.selectedOption.priceRequest ? 'Preisvorschlag' : `Preisvorschlag: ${accordion.accordion6.steps.price.selectedOption.priceRequest} €`}`

        case 'submit':
          return 'Erhalten Sie noch heute Ihr individuelles Angebot'
        default:
          return ''
      }
    },
    async transformAccordionToFormData() {
      const accordion = this.accordion
      const requestData = {
        model: accordion.accordion1.steps.modelVariant.selectedOption.label,
        registration: accordion.accordion2.steps.carRegistration.selectedOption.registration,
        mileage: accordion.accordion2.steps.carRegistration.selectedOption.mileage,
        previousOwner: accordion.accordion2.steps.carRegistration.selectedOption.previousOwner,
        location: accordion.accordion2.steps.carRegistration.selectedOption.location,
        bodyColor: accordion.accordion3.steps.bodyColor.selectedOption?.label ?? '',
        interiorColor: accordion.accordion3.steps.interiorColor.selectedOption?.label ?? '',
        rimColor: accordion.accordion3.steps.rimColor.selectedOption?.label ?? '',
        rims: [
          accordion.accordion4.steps.rims.selectedOption?.label,
          accordion.accordion4.steps.rimType.selectedOption?.label
        ]
          .filter(Boolean)
          .join(', '),
        autopilot:
          accordion.accordion4.steps.autopilot.selectedOption?.label ?? 'Autopilot (Standard)',
        price: accordion.accordion6.steps.price.selectedOption.priceRequest,
        firstName: accordion.accordion7.steps.submit.selectedOption.firstName,
        lastName: accordion.accordion7.steps.submit.selectedOption.lastName,
        email: accordion.accordion7.steps.submit.selectedOption.email,
        phone: accordion.accordion7.steps.submit.selectedOption.phone,
        message: accordion.accordion7.steps.submit.selectedOption.message || ''
      }
      requestData.driveType =
        accordion.accordion1.steps.modelVariant.selectedOption.value === 'Model3LongRange' ||
        accordion.accordion1.steps.modelVariant.selectedOption.value === 'ModelYLongRange'
          ? accordion.accordion1.steps.driveType.selectedOption.label
          : null
      requestData.availableFrom = accordion.accordion2.steps.carRegistration.selectedOption
        .availability
        ? null
        : accordion.accordion2.steps.carRegistration.selectedOption.availableFrom

      requestData.accident = accordion.accordion5.steps.accident.selectedOption.accident
        ? accordion.accordion5.steps.accident.selectedOption.accidentDescription
        : null
      requestData.damages = accordion.accordion5.steps.damage.selectedOption.damage
        ? accordion.accordion5.steps.damage.selectedOption.damageDescription
        : null
      requestData.saleType =
        accordion.accordion6.steps.price.selectedOption.saleType === 'Privater Verkauf'
          ? accordion.accordion6.steps.price.selectedOption.saleType
          : accordion.accordion6.steps.price.selectedOption.mwSt
            ? 'Gewerblicher Verkauf (MwSt. ausweisbar)'
            : 'Gewerblicher Verkauf (MwSt. nicht ausweisbar)'
      requestData.purchaseType = !accordion.accordion6.steps.finance.selectedOption.financing
        ? 'Keine Finanzierung'
        : accordion.accordion6.steps.finance.selectedOption.vehicleLetterAtBank
          ? 'Finanzierung, KFZ-Brief liegt bei der Bank'
          : 'Finanzierung, KFZ-Brief liegt bei mir'

      const customEquipmentSelectedOption =
        accordion.accordion4.steps.customEquipment.selectedOption
      const customEquipmentValue = customEquipmentSelectedOption.find(
        (option) => option.label === 'custom-equipment'
      )

      const customEquipmentLabels = customEquipmentSelectedOption
        .filter((option) => option.label !== 'custom-equipment')
        .map((option) => option.label)

      if (customEquipmentValue && customEquipmentValue.value !== '') {
        requestData.customEquipment = customEquipmentValue.value
      } else {
        requestData.customEquipment = ''
      }

      requestData.equipment = customEquipmentLabels
      requestData.marketing = accordion.accordion7.steps.submit.selectedOption.marketing.map(
        (option) => option.label
      )

      const urlParams = new URLSearchParams(window.location.search)
      const isDebugMode = urlParams.get('debugMode')

      requestData.debugMode = isDebugMode
      this.requestData = requestData
      if (isDebugMode) {
        console.log('Request data:', JSON.stringify(this.requestData, null, 2))
      }
      return requestData
    },

    async sendRequest() {
      try {
        this.transformAccordionToFormData()

        this.loading = true

        const url = `https://fn.cloud.audaris.icu/2129/pre-tradein-widget`
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.requestData)
        })
        //console.log('this is the response', response)
        if (!response.ok) {
          this.handleFetchError(response.status)
          return
        }
        //console.log(response.status)

        if (response.status === 200) {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'sent-contact-form' })

          this.responseDataCheck = true
        }
      } catch (error) {
        console.error('Fehler beim Fetchen der Daten:', error)
      } finally {
        this.loading = false
      }
    },

    handleFetchError(status) {
      switch (status) {
        case 429:
          this.requestError = 'Zu viele Anfragen, bitte versuche es später noch einmal'
          break
        default:
          this.requestError = `Fehler ${status}: ${this.getErrorMessage(status)}`
      }
    },

    getErrorMessage(status) {
      switch (status) {
        case 400:
          return 'Ungültige Anfrage'
        case 401:
          return 'Authentifizierung fehlgeschlagen'
        case 500:
          return 'Interner Serverfehler'
        default:
          return 'Unbekannter Fehler'
      }
    }
  }
})
